import { APP_ENV, ENV_CONFIG_KEY, NODE_ENV } from '../consts'
import getURLSearchParam from './url'
import { AnyJSON } from '@zhenguo/types/common'

export enum E_ProcessEnv {
  VUE_APP_ENV = 'VUE_APP_ENV',
  NODE_ENV = 'NODE_ENV',
  VUE_APP_FILENAMES = 'VUE_APP_FILENAMES',
  VUE_APP_SWIMLANE = 'VUE_APP_SWIMLANE',
  VUE_APP_LITE_SET = 'VUE_APP_LITE_SET',
  VUE_APP_API_HOST = 'VUE_APP_API_HOST',
  VUE_APP_ACTIVITY_ID = 'VUE_APP_ACTIVITY_ID',
  VUE_APP_PROJECT_NAME = 'VUE_APP_PROJECT_NAME',
  VUE_APP_TEMPLATE_KEY = 'VUE_APP_TEMPLATE_KEY',
  VUE_APP_DOMAIN_ACTIVITY = 'VUE_APP_DOMAIN_ACTIVITY',
  VUE_APP_DEPLOY_ENV = 'VUE_APP_DEPLOY_ENV',
  VUE_APP_LOGIN_URL = 'VUE_APP_LOGIN_URL',
  VUE_APP_LOGOUT_URL = 'VUE_APP_LOGOUT_URL',
  VUE_APP_LOGIN_SETTOKEN = 'VUE_APP_LOGIN_SETTOKEN',
  VUE_APP_ILOGIN_URL = 'VUE_APP_ILOGIN_URL',
  VUE_APP_ADDRESS_ENV = 'VUE_APP_ADDRESS_ENV',
  VUE_APP_DOMAIN_IPHX = 'VUE_APP_DOMAIN_IPHX',
  VUE_APP_DOMAIN_PC = 'VUE_APP_DOMAIN_PC',
  VUE_APP_SCENE_TOKEN_STORAGE_READ = 'VUE_APP_SCENE_TOKEN_STORAGE_READ',
  VUE_APP_SCENE_TOKEN_PHOTOS = 'VUE_APP_SCENE_TOKEN_PHOTOS',
  VUE_APP_SCENE_TOKEN_CITY = 'VUE_APP_SCENE_TOKEN_CITY',
  VUE_APP_SCENE_TOKEN_STORAGE_WRITE = 'VUE_APP_SCENE_TOKEN_STORAGE_WRITE',
  VUE_APP_LOGIN_RISK_PARTNER = 'VUE_APP_LOGIN_RISK_PARTNER',
  VUE_APP_SSO = 'VUE_APP_SSO',
  VUE_APP_PLATFORM_BASE_URL = 'VUE_APP_PLATFORM_BASE_URL',
  VUE_APP_PLATFORM_CART_BASE_URL = 'VUE_APP_PLATFORM_CART_BASE_URL',
  VUE_APP_LOGOUT_HOST = 'VUE_APP_LOGOUT_HOST'
}

export const liteset = (() => {
  const value = getURLSearchParam('liteset') || getProcessEnv(E_ProcessEnv.VUE_APP_LITE_SET)
  if (value) return value.indexOf('gray-release-') === -1 ? 'gray-release-' + value : value
  return ''
})()

export const swimlane = (() => {
  let swimlane = getURLSearchParam('swimlane') || getProcessEnv(E_ProcessEnv.VUE_APP_SWIMLANE)
  return swimlane
})()

export function getAppEnv(): APP_ENV {
  if (process.env[E_ProcessEnv.VUE_APP_ENV] === APP_ENV.production) {
    return APP_ENV.production
  }
  if (liteset) {
    return APP_ENV.staging
  }
  if (swimlane) {
    return APP_ENV.test
  }
  const queryAppEnv = getURLSearchParam('phx_env')
  if (Object.keys(APP_ENV).indexOf(queryAppEnv) !== -1) {
    return queryAppEnv as APP_ENV
  }
  return (process.env[E_ProcessEnv.VUE_APP_ENV] as APP_ENV) || APP_ENV.production
}

function getLocalStorage(key: string) {
  try {
    return JSON.parse(window.localStorage.getItem(key) || '') || undefined
  } catch (err) {
    return undefined
  }
}

export function getProcessEnv(key: E_ProcessEnv) {
  const env = getAppEnv()
  if (env !== APP_ENV.production && env !== process.env[E_ProcessEnv.VUE_APP_ENV]) {
    const envConfig: AnyJSON = getLocalStorage(ENV_CONFIG_KEY)
    const value = envConfig && envConfig[env] ? envConfig[env][key] || process.env[key] : undefined
    // console.log('[ProcessEnv]', env, key, value)
    return value
  }
  return process.env[key]
}

export function isEnvProd() {
  return process.env[E_ProcessEnv.VUE_APP_ENV] === APP_ENV.production
}

export function isNodeProd() {
  return process.env[E_ProcessEnv.NODE_ENV] === NODE_ENV.production
}
